__turbopack_context__.v({
  "body": "oqoVja_body",
  "bodyInner": "oqoVja_bodyInner",
  "hint": "oqoVja_hint",
  "toggle": "oqoVja_toggle",
});
